/* global templateAssignUrl templateAssignUpdateUrl */
import React, { useState } from 'react';

import PackTable from '../packs/view/PackTable';
import TemplateAssign from '../templates/TemplateAssign';

import UncommittedExpendituresEditForm from './UncommittedExpendituresEditForm';

import Button from 'CommonComponents/Button';
import ModalFooter from 'CommonComponents/ModalFooter';
import ModalHeader from 'CommonComponents/ModalHeader';

export default function UncommittedExpendituresEditModal(props) {
    const [response, setResponse] = useState({});
    const [isBudgetted, setIsBudgetted] = useState(-1);
    const [confirmProceedData, setConfirmProceedData] = useState(null);

    const internalSuccessHandler = (response) => {
        if (response.expenseFundApprovalId) {
            setResponse(response);
        } else {
            internalCloseHandler();
        }
    };

    const closeHandler = () => {
        setConfirmProceedData(null);
        props.closeHandler();
    };

    const internalCloseHandler = () => {
        setResponse({});
        setIsBudgetted(-1);
        props.updateSuccessHandler();
    };

    // The pot the variance moves: the line's own, else its department's, else central.
    const contingencyPotLabel = () => (response.contingencyPotName ? `${response.contingencyPotName} (${response.contingencyAvailable ?? 0})` : $t('Central'));

    const requestContingency = () => {
        if (response.totalNew - response.totalOld > response.contingencyAvailable && response.expenseFundApprovalId) {
            axios
                .patch(props.expenseFundApprovalsUpdateUrl.replace('EXPENSE_FUND_APPROVAL_ID', response.expenseFundApprovalId), {
                    isBudgetted: 1,
                    totalNew: response.totalNew,
                    totalOld: response.totalOld,
                })
                .then((response) => {
                    setIsBudgetted(1);
                })
                .catch((e) => {
                    setIsBudgetted(-1);
                });
        } else {
            setIsBudgetted(1);
        }
    };

    const cancelRequestContingency = () => {
        if (response.expenseFundApprovalId) {
            axios
                .patch(props.expenseFundApprovalsUpdateUrl.replace('EXPENSE_FUND_APPROVAL_ID', response.expenseFundApprovalId), { isBudgetted: 0 })
                .then((response) => {
                    setIsBudgetted(0);
                })
                .catch((e) => {
                    setIsBudgetted(-1);
                });
        } else {
            setIsBudgetted(0);
        }
    };

    return (
        <div id={props.modalId} ref={props.modalRef} tabIndex="-1" aria-hidden="true" className="hidden modal__box">
            <div
                className={
                    Object.keys(props.uncommittedExpenditure).length > 0 &&
                    (props.uncommittedExpenditure.expense.type === 'template' || props.uncommittedExpenditure.expense.type === 'pack')
                        ? 'modal__container !tw-max-w-7xl'
                        : 'modal__container'
                }
            >
                <div className="modal__inner-container">
                    {Object.keys(props.uncommittedExpenditure).length > 0 ? (
                        <>
                            <ModalHeader title={$t('Edit Expense') + ' ' + props.uncommittedExpenditure.expense.name} close={closeHandler}></ModalHeader>
                            {Object.keys(response).length == 0 && isBudgetted === -1 && (
                                <div className="tw-rounded-b">
                                    {confirmProceedData && (
                                        <>
                                            <h6 className="tw-my-3">{confirmProceedData.forAdding ? 'Added To' : 'Taken From'}</h6>
                                            <div className="inbud-table_wrapper tw-mb-3">
                                                <table className="inbud-table tw-table-auto">
                                                    <thead>
                                                        <tr>
                                                            <th>{$t('Local Contingency')}</th>
                                                            <th>{$t('Central Contingency')}</th>
                                                            <th>{$t('Event Profit')}</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td>
                                                                <input
                                                                    className={
                                                                        confirmProceedData.isLocalContingencyAvailable
                                                                            ? 'w-border-0 text-input'
                                                                            : 'w-border-0 text-input !tw-bg-gray-400'
                                                                    }
                                                                    type="text"
                                                                    disabled
                                                                    value={confirmProceedData.takenFromLocalContingency}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    className={
                                                                        confirmProceedData.isCentralContingencyAvailable
                                                                            ? 'w-border-0 text-input'
                                                                            : 'w-border-0 text-input !tw-bg-gray-400'
                                                                    }
                                                                    type="text"
                                                                    disabled
                                                                    value={confirmProceedData.takenFromCentralContingency}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    className={
                                                                        confirmProceedData.eventProfitEnabled
                                                                            ? 'w-border-0 text-input'
                                                                            : 'w-border-0 text-input !tw-bg-gray-400'
                                                                    }
                                                                    type="text"
                                                                    disabled
                                                                    value={confirmProceedData.takenFromEventProfit}
                                                                />
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </>
                                    )}

                                    <div className="modal__form-container">
                                        {props.uncommittedExpenditure.expense.type === 'expense' && props.uncommittedExpenditure.expense.assign === 'event' && (
                                            <UncommittedExpendituresEditForm
                                                uncommittedExpenditure={props.uncommittedExpenditure}
                                                uncommittedExpendituresUpdateUrl={props.uncommittedExpendituresUpdateUrl}
                                                uncommittedExpendituresPreCommitUrl={props.uncommittedExpendituresPreCommitUrl}
                                                isProjectSblExpense={props.isProjectSblExpense()}
                                                successHandler={internalSuccessHandler}
                                                displayConfirmProceed={(response) => setConfirmProceedData(response)}
                                            />
                                        )}
                                        {props.uncommittedExpenditure.expense.type === 'expense' && props.uncommittedExpenditure.expense.assign == 'venue' && (
                                            <div id="TemplateAssign">
                                                <TemplateAssign
                                                    cellW="160"
                                                    cellH="80"
                                                    dividerW="160"
                                                    dividerH="100"
                                                    editable="true"
                                                    templateAssignUrl={templateAssignUrl.replace('UNCOMMITTED_EXPENDITURE_ID', props.uncommittedExpenditure.id)}
                                                    templateAssignUpdateUrl={templateAssignUpdateUrl.replace(
                                                        'UNCOMMITTED_EXPENDITURE_ID',
                                                        props.uncommittedExpenditure.id,
                                                    )}
                                                    templateAssignUpdateUrlMethod="PUT"
                                                    successHandler={internalSuccessHandler}
                                                    canBeEdited={
                                                        props.uncommittedExpenditure.expense.can_be_edited === undefined
                                                            ? true
                                                            : !!props.uncommittedExpenditure.expense.can_be_edited
                                                    }
                                                />
                                            </div>
                                        )}
                                        {props.uncommittedExpenditure.expense.type === 'template' && (
                                            <div id="TemplateAssign">
                                                <TemplateAssign
                                                    cellW="160"
                                                    cellH="80"
                                                    dividerW="160"
                                                    dividerH="100"
                                                    editable="true"
                                                    templateAssignUrl={templateAssignUrl.replace('UNCOMMITTED_EXPENDITURE_ID', props.uncommittedExpenditure.id)}
                                                    templateAssignUpdateUrl={templateAssignUpdateUrl.replace(
                                                        'UNCOMMITTED_EXPENDITURE_ID',
                                                        props.uncommittedExpenditure.id,
                                                    )}
                                                    templateAssignUpdateUrlMethod="PUT"
                                                    successHandler={internalSuccessHandler}
                                                    selectable={true}
                                                    canBeEdited={
                                                        props.uncommittedExpenditure.expense.can_be_edited === undefined
                                                            ? true
                                                            : !!props.uncommittedExpenditure.expense.can_be_edited
                                                    }
                                                    forProcurement={false}
                                                />
                                            </div>
                                        )}
                                        {props.uncommittedExpenditure.expense.type === 'pack' && (
                                            <PackTable
                                                key={`pack-edit-${props.uncommittedExpenditure.id}`}
                                                editable={true}
                                                dataUrl={templateAssignUrl.replace('UNCOMMITTED_EXPENDITURE_ID', props.uncommittedExpenditure.id)}
                                                updateUrl={templateAssignUpdateUrl.replace('UNCOMMITTED_EXPENDITURE_ID', props.uncommittedExpenditure.id)}
                                                cellW="160"
                                                cellH="90"
                                                dividerW="160"
                                                dividerH="100"
                                                successHandler={internalSuccessHandler}
                                            />
                                        )}
                                    </div>
                                </div>
                            )}
                            {Object.keys(response).length > 0 && isBudgetted === -1 && (
                                <div className="tw-rounded-b">
                                    <div className="modal__form-container">
                                        <div className="tw-grid tw-grid-cols-1">
                                            <p className="modal__text">
                                                {$t(
                                                    'Updating this expense will change the total budgeted amount from {{response_total_old}} to {{response_total_new}}',
                                                    { response_total_old: response.totalOld, response_total_new: response.totalNew },
                                                )}
                                                .
                                            </p>
                                        </div>
                                        {response.projectUnallocatedAmountAvailable != 0 && (
                                            <div className="tw-grid tw-grid-cols-1">
                                                <p className="modal__text">
                                                    {$t(
                                                        'It will use {{response_project_unallocated_amount_available}} of unallocated amount available on the Project the expense belongs to',
                                                        { response_project_unallocated_amount_available: response.projectUnallocatedAmountAvailable },
                                                    )}
                                                </p>
                                            </div>
                                        )}

                                        {response.totalNewGlobal != 0 && (
                                            <div className="tw-grid tw-grid-cols-1">
                                                <p className="modal__text">
                                                    {$t('It will also change other Packs where this Pack Child is assigned in {{response_total_new_global}}', {
                                                        response_total_new_global: response.totalNewGlobal,
                                                    })}
                                                    .
                                                </p>
                                            </div>
                                        )}
                                        {response.totalNew + response.totalNewGlobal - response.totalOld - response.projectUnallocatedAmountAvailable >
                                        response.contingencyAvailable ? (
                                            <div className="tw-grid tw-grid-cols-1">
                                                <p className="modal__text">
                                                    {$t(
                                                        'The variance of {{model_variance_of}} will be added to / taken from contingency of the {{contingency_model}}. Do you want to request use of central contingency for additional amount {{central_variance_of}}?',
                                                        {
                                                            model_variance_of: (
                                                                response.totalNew +
                                                                response.totalNewGlobal -
                                                                response.projectUnallocatedAmountAvailable -
                                                                response.totalOld
                                                            ).toFixed(2),
                                                            contingency_model: contingencyPotLabel(),
                                                            central_variance_of: (
                                                                response.totalNew +
                                                                response.totalNewGlobal -
                                                                response.totalOld -
                                                                response.projectUnallocatedAmountAvailable -
                                                                response.contingencyAvailable
                                                            ).toFixed(2),
                                                        },
                                                    )}
                                                </p>
                                            </div>
                                        ) : (
                                            <div className="tw-grid tw-grid-cols-1">
                                                <p className="modal__text">
                                                    {$t(
                                                        'The variance of {{model_variance_of}} will be added to / taken from contingency of the {{contingency_model}}.',
                                                        {
                                                            model_variance_of: (
                                                                response.totalNew +
                                                                response.totalNewGlobal -
                                                                response.projectUnallocatedAmountAvailable -
                                                                response.totalOld
                                                            ).toFixed(2),
                                                            contingency_model: contingencyPotLabel(),
                                                        },
                                                    )}
                                                </p>
                                            </div>
                                        )}
                                        <ModalFooter
                                            cancelButtonText={$t('Cancel')}
                                            primaryButtonText={$t('OK')}
                                            onCancel={cancelRequestContingency}
                                            handleSubmit={requestContingency}
                                            isSubmitting={false}
                                        ></ModalFooter>
                                    </div>
                                </div>
                            )}
                            {isBudgetted > -1 && (
                                <div className="tw-rounded-b">
                                    <div className="modal__form-container">
                                        <div className="tw-grid tw-grid-cols-1">
                                            <label className="modal__msg modal__text-color">{$t('Expense Updated')}</label>
                                        </div>
                                        <div className="modal__footer">
                                            <Button variant="secondary" onClick={internalCloseHandler}>
                                                {$t('Close')}
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </>
                    ) : (
                        <>
                            <ModalHeader title={$t('Edit Expense')} close={props.closeHandler}></ModalHeader>
                            <div className="tw-rounded-b">
                                <div className="modal__form-container">
                                    <div className="tw-grid tw-grid-cols-1">
                                        <label className="modal__msg modal__text-color">{$t('Choose one expense to edit')}</label>
                                    </div>
                                </div>
                            </div>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
}
